"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSecretFormData = exports.validateSecretFormData = void 0;
const i18next_1 = __importDefault(require("i18next"));
const validateSecretFormData = ({ secret_password, secret_hint, }) => {
    const validateLength = (v) => Boolean(v === null || v === void 0 ? void 0 : v.replace(/\s/g, '').length);
    let validation = [];
    if (!validateLength(secret_password))
        validation.unshift(i18next_1.default.t('비밀번호를 작성해주세요'));
    if (!validateLength(secret_hint))
        validation.unshift(`${i18next_1.default.t('비밀번호')} ${i18next_1.default.t('힌트를 작성해주세요')}`);
    return validation;
};
exports.validateSecretFormData = validateSecretFormData;
const generateSecretFormData = ({ isPromiseForm, is_secret, secret_password, secret_hint, }) => {
    if (isPromiseForm) {
        return { is_secret: false };
    }
    let secretDataObj = { is_secret };
    if (is_secret) {
        Object.assign(secretDataObj, { secret_password, secret_hint });
    }
    return secretDataObj;
};
exports.generateSecretFormData = generateSecretFormData;
